import React from 'react'

import ControlledLottieAnimation from 'components/common/ControlledLottieAnimation'
import LottieAnimation from 'components/common/Lottie'
import { gesturesData, gestureTypes } from 'components/Tiles/Student/Gestures'
import { userTypes } from 'constants/user'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { sendRevertGesture } from 'services/webSockets/gestures'

import { CrossImageContainer, CrossImage } from './styles'

import { Wrapper } from '../styles'

const Gesture = ({ gestureKey, gestureType, gesturePK, isLocal, visible }) => {
    const { userType } = useVideoContext()

    if (!visible || !gestureKey) return null

    const isTeacher = userType === userTypes.TEACHER

    const gesture = gesturesData.find(item => item.gestureKey === gestureKey)

    const isStaticGesture = gesture.autoRevert === false

    const lottieProps = {
        src: gesture.assetPath,
        style: {
            width: '60%',
            height: '60%',
            margin: isStaticGesture ? '40% auto 0 auto' : '20%',
        },
    }

    const showRevertButton =
        gesturePK &&
        gestureType === gestureTypes.static &&
        (isTeacher || isLocal)

    const handleRevertGesture = event => {
        // first find id of element , i.e gesture_pk
        const { id } = event.target

        // now fire revert gesture
        sendRevertGesture(Number.parseInt(id))
    }

    let animation = <LottieAnimation {...lottieProps} />
    if (showRevertButton) {
        animation = <ControlledLottieAnimation loops={2} {...lottieProps} />
    }

    return (
        <Wrapper isTeacher={isTeacher} isStaticGesture={isStaticGesture}>
            {animation}
            {showRevertButton ? (
                <CrossImageContainer onClick={handleRevertGesture}>
                    <CrossImage
                        src="/assets/revamp/cross.svg"
                        alt="close-gesture-button"
                        id={gesturePK}
                    />
                </CrossImageContainer>
            ) : null}
        </Wrapper>
    )
}

export { Gesture }
